<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add">
      新增
    </a-button>
    <a-modal centered v-model="visible" title="新增优惠券" @ok="handleOk">
      <p>类型</p>
      <a-select
        v-model="formInline.type"
        default-value="1104"
        style="width: 120px"
        @change="handleChange"
        placeholder=""
      >
        <!-- 2024/11/14 暂时隐藏, 因为功能还没完成 -->
        <!--<a-select-option value="1104"> 礼品券</a-select-option>-->
        <a-select-option value="1000">满减券</a-select-option>
        <a-select-option value="1105"> 代币券</a-select-option>
      </a-select>
      <!-- 礼品券 -->
      <div v-if="right === 1104">
        <p>礼品名称</p>
        <a-input v-model="formInline.title" placeholder="请输入礼品名称"/>
        <p>有效期</p>
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="formInline.effectiveDate"
          @change="onChangess"
        />
        <p>礼品图片</p>
        <a-upload
          :default-file-list="defaultFileList"
          :customRequest="upload"
          @preview="handlePreview"
        >
          <a-button>
            <a-icon type="upload"/>
            Upload
          </a-button>
        </a-upload>
        <p>使用说明</p>
        <a-textarea
          v-model="formInline.instructions"
          placeholder="请输入礼品使用说明"
          :rows="4"
        />
      </div>
      <!-- 代币券 -->
      <div v-else-if="right === 1105">
        <p>活动名称</p>
        <a-input v-model="formInline.title" placeholder="请输入活动名称"/>

        <p>赠送数量</p>
        <a-input-number v-model="formInline.numberGrant" placeholder="请输入赠送数量(领取后获得多少个代币)"/>

        <p>领取数量</p>
        <a-input-number v-model="formInline.numberReceive" placeholder="多少个用户领取后就不可领取"/>

        <p>活动有效期</p>
        <a-date-picker :placeholder="formInline.effectiveDate" format="YYYY-MM-DD"
                       v-model="formInline.effectiveDate" @change="onChangess"/>
        <p>代币券使用说明</p>
        <a-textarea
          v-model="formInline.instructions"
          placeholder="请输入代币券使用说明"
          :rows="4"
        />
      </div>
      <!-- 满减券 -->
      <div v-else>
        <p>活动名称</p>
        <a-input v-model="formInline.title" placeholder="请输入满减活动名称"/>
        <p>有效期</p>
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="formInline.effectiveDate"
          @change="onChangess"
        />
        <p>满多少金额</p>
        <a-input-number v-model="formInline.priceFull" placeholder="请输入满多少金额"/>
        <p>减多少金额</p>
        <a-input-number v-model="formInline.priceDiscount" placeholder="请输入减多少金额"/>
        <p>使用说明</p>
        <a-textarea
          v-model="formInline.instructions"
          placeholder="请输入满减券使用说明"
          :rows="4"
        />
      </div>
    </a-modal>
    <a-modal centered v-model="visibles" title="修改优惠券" @ok="handleOks">
      <p>类型</p>
      <a-select
        v-model="formInlines.type"
        default-value="1104"
        style="width: 120px"
        placeholder="请选择"
        @change="handleChange"
        disabled
      >
        <!-- 2024/11/14 暂时隐藏, 因为功能还没完成 -->
        <!--<a-select-option value="1104"> 礼品券</a-select-option>-->
        <a-select-option value="1000">满减券</a-select-option>
        <a-select-option value="1105"> 代币券</a-select-option>
      </a-select>
      <!-- 礼品券 -->
      <div v-if="right === 1104">
        <p>礼品名称</p>
        <a-input
          disabled
          v-model="formInlines.title"
          placeholder="请输入礼品名称"
        />
        <p>有效期</p>
        <a-date-picker
          :placeholder="formInlines.effectiveDate"
          format="YYYY-MM-DD"
          v-model="formInlines.effectiveDate"
          @change="onChangess"
        />
        <p>礼品图片</p>
        <a-upload
          :default-file-list="defaultFileList"
          :customRequest="upload"
          @preview="handlePreview"
        >
          <a-button>
            <a-icon type="upload"/>
            Upload
          </a-button>
        </a-upload>
        <p>使用说明</p>
        <a-textarea
          v-model="formInlines.instruction"
          placeholder="请输入礼品使用说明"
          :rows="4"
        />
      </div>
      <!-- 代币券 -->
      <div v-else-if="right === 1105">
        <p>活动名称</p>
        <a-input v-model="formInlines.title" placeholder="请输入活动名称"/>

        <p>赠送数量</p>
        <a-input-number v-model="formInlines.numberGrant" placeholder="请输入赠送数量(领取后获得多少个代币)"/>

        <p>领取数量</p>
        <a-input-number v-model="formInlines.numberReceive" placeholder="多少个用户领取后就不可领取"/>

        <p>活动有效期</p>
        <a-date-picker :placeholder="formInlines.effectiveDate" format="YYYY-MM-DD"
                       v-model="formInlines.effectiveDate" @change="onChangess"/>
        <p>代币券使用说明</p>
        <a-textarea
          v-model="formInlines.instructions"
          placeholder="请输入代币券使用说明"
          :rows="4"
        />
      </div>
      <!-- 满减券 -->
      <div v-else>
        <p>活动名称</p>
        <a-input v-model="formInlines.title" placeholder="请输入满减活动名称"/>
        <p>有效期</p>
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="formInlines.effectiveDate"
          @change="onChangess"
        />
        <p>满多少金额</p>
        <a-input-number v-model="formInlines.priceFull" placeholder="请输入满多少金额"/>
        <p>减多少金额</p>
        <a-input-number v-model="formInlines.priceDiscount" placeholder="请输入减多少金额"/>
        <p>使用说明</p>
        <a-textarea
          v-model="formInlines.instructions"
          placeholder="请输入满减券使用说明"
          :rows="4"
        />
      </div>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="type" slot-scope="type">
        <span> {{ type === 1000 ? "满减券" : (type === 1105 ? "代币券" : "礼品券") }}</span>
      </template>
      <a-avatar slot="avatar" icon="user"/>
      <span slot="memberStatus" slot-scope="text, record">
        <a-switch
          checked-children="开启"
          un-checked-children="未开启"
          :checked="record.shelf === true ? true : false"
          @change="onChange(record)"
        />
      </span>
      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/offerManagement/usageDetailsHome?objId=${operate.objId}`
            )
          "
        >用户使用详情</a
        >
        <a href="javascript:;" @click="edit(operate)">修改</a>
        <a href="javascript:;" @click="del(operate)">删除</a>
        <a v-if="operate.type === 1000" href="javascript:;" @click="pushMes(operate)">信息推送</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  couponsList,
  picUpload,
  addCouponsList,
  updateCouponsList,
  delCouponsList,
  storeCoupons,
  storeCouponsDetalis,
  mesPush
} from "@/api/storeApi.js";
import {message} from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: {customRender: "objId"},
  },
  {
    title: "券码",
    dataIndex: "discountCode",
  },
  {
    title: "优惠券类型",
    dataIndex: "type",
    scopedSlots: {customRender: "type"},
  },
  {
    title: "赠送数量(代币券)",
    dataIndex: "numberGrant",
  },
  {
    title: "标题",
    dataIndex: "title",
    sorter: true,
  },
  {
    title: "满多少金额",
    dataIndex: "priceFull",
    sorter: true,
  },
  {
    title: "减多少金额",
    dataIndex: "priceDiscount",
    sorter: true,
  },
  {
    title: "有效期",
    dataIndex: "effectiveDateStr",
    sorter: true,
  },
  {
    title: "适用门店",
    dataIndex: "shopName",
    sorter: true,
    scopedSlots: {customRender: "shopName"},
  },
  {
    title: "状态",
    dataIndex: "shelf",
    sorter: true,
    scopedSlots: {customRender: "memberStatus"},
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: {customRender: "operate"},
  },
];

export default {
  data() {
    return {
      right: "1104",
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      defaultFormInline: {
        type: "",
        title: "",
        img: "",
        effectiveDate: "",
        instructions: "",
        priceDiscount: "0",
        priceFull: "0",
        numberGrant: 1, // 代币的赠送数量, 意思是领取之后得到多少代币(数据库的默认值就是10000000)
        numberReceive: 10000000,
      },
      formInline: {},
      formInlines: {},
      loading: false,
      columns,
      visible: false,
      visibles: false,
    };
  },
  mounted() {
    this.getCouponsList();
    this.formInline = {...this.defaultFormInline};
    // 新增一个objId
    this.formInlines = {...this.defaultFormInline, objId: ""};
  },
  props: ["offer"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      couponsList({limit: 10, page: this.pagination.current}).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    getCouponsList() {
      couponsList({limit: 10, page: 1}).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    //
    onChange(row) {
      if (row.shelf === true) {
        storeCoupons(row.objId, false).then((res) => {
          this.getCouponsList();
          message.success("操作成功");
        });
      } else {
        storeCoupons(row.objId, true).then((res) => {
          this.getCouponsList();
          message.success("操作成功");
        });
      }
    },
    onChangess(date, dateString) {
      this.formInline.effectiveDate = dateString;
      this.formInlines.effectiveDate = dateString;
    },
    handleChange(checked) {
      const couponType = this.getRealCouponType(checked);
      console.log(`value=${couponType}`);
      this.right = Number(couponType);
      this.formInlines.type = couponType;
    },
    query() {
      this.loading = true;
      couponsList(this.offer).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    add() {
      this.visible = true;
    },
    del(row) {
      this.loading = true;
      delCouponsList(row.objId).then((res) => {
        this.loading = false;
        this.getCouponsList();
      });
    },
    pushMes(row) {
      this.loading = true;
      mesPush(row.objId, 5).then((res) => {
        this.loading = false;
        message.success(res.data);
      });
    },
    edit(row) {
      // console.log(row);
      this.visibles = true;
      this.formInlines.objId = row.objId;
      storeCouponsDetalis(row.objId).then((res) => {
        const couponType = Number(res.data.type);
        console.log(couponType);
        this.right = couponType;
        if (couponType === 1104) {
          this.formInlines.type = "礼品券";
        } else if (couponType === 1105) {
          this.formInlines.type = "代币券";
          this.formInlines.numberGrant = res.data.numberGrant;
          this.formInlines.numberReceive = res.data.numberReceive;
        } else {
          this.formInlines.type = "满减券";
          this.formInlines.priceFull = res.data.priceFull;
          this.formInlines.priceDiscount = res.data.priceDiscount;
        }
        this.formInlines.title = res.data.title;
        this.formInlines.instructions = res.data.instructions;
        this.formInlines.effectiveDate = res.data.effectiveDateStr;
      });
    },
    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.formInline.img = res.data;
          file.onSuccess(res, file);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    //
    handleOk() {
      this.visible = false;
      if (this.right !== 1105) {
        this.$delete(this.formInline, "numberGrant");
      }
      addCouponsList(this.formInline).then((res) => {
        this.getCouponsList();
        message.success(res.info);
        this.formInline = {...this.defaultFormInline};
      });
    },
    handleOks() {
      this.visibles = false;
      this.formInlines.type = this.getRealCouponType(this.formInlines.type);
      if (this.right !== 1105) {
        this.$delete(this.formInlines, "numberGrant");
      }
      updateCouponsList(this.formInlines).then((res) => {
        this.getCouponsList();
        message.success(res.info);
        this.formInlines = {...this.defaultFormInline, objId: ""};
      });
    },
    // 获取真实的优惠券类型
    getRealCouponType(val) {
      switch (val) {
        case "礼品券":
          return 1104;
        case "代币券":
          return 1105;
        case "满减券":
          return 1000;
        default:
          return Number(val);
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/marketingManagement/offerManagement/offerManagementHomeContent.vue